export default "__VITE_ASSET__DAhO_zxr__"